/**
 * 路由预请求逻辑
 * 在路由守卫中提前发起请求，组件创建时数据可能已准备好
 */
import { getBrandInfo } from '@/api/modules/brand'
import { shopIndex } from '@/api/modules/store'
import { setLocalStorage } from '@/utils/localStorage'
import storeRouterChange from '@/utils/storeRouterChange'
import { is_mobile } from '@/utils/os'

/**
 * 处理品牌页预请求
 */
function prefetchBrandInfo(to) {
  if (to.name === 'brand' || to.path.includes('/brand/')) {
    const brandId = to.params?.brandId?.slice(0, 7)
    if (brandId) {
      // 直接发起请求，不校验缓存
      getBrandInfo({ brandTicket: brandId })
        .then(res => {
          if (res && !Object.prototype.hasOwnProperty.call(res, 'errno')) {
            const cacheKey = `brandInfo_${brandId}`
            const payload = {
              data: res,
              timestamp: Date.now(),
            }
            // 保存到缓存
            setLocalStorage(cacheKey, payload)

            // 通过全局事件通知品牌页：预取数据已准备好
            try {
              window.dispatchEvent(
                new CustomEvent('brandInfoPrefetched', {
                  detail: {
                    brandId,
                    cacheKey,
                    payload,
                  },
                }),
              )
            } catch (e) {
              // 某些环境可能不支持 CustomEvent，忽略即可
            }
          } else {
            window.dispatchEvent(
              new CustomEvent('brandInfoPrefetched', {
                detail: {
                  brandId,
                  errno: res.errno,
                },
              }),
            )
          }
        })
        .catch(() => {
          // 静默处理错误，不影响路由跳转
        })
    }
  }
}

/**
 * 处理商家页预请求
 */
function prefetchShopIndex(to) {
  if (to.name === 'store' || to.path.includes('/store/')) {
    const paramsShopId = to.params?.storeId?.slice(0, 6)
    const storageShopTicket = storeRouterChange.getShopTicket()
    const shopId = paramsShopId || storageShopTicket

    if (shopId) {
      // 直接发起请求，不校验缓存
      shopIndex({ shopTicket: shopId })
        .then(res => {
          if (res && !Object.prototype.hasOwnProperty.call(res, 'errno')) {
            const cacheKey = `shopIndex_${shopId}`
            const payload = {
              data: res,
              timestamp: Date.now(),
            }
            // 保存到缓存
            setLocalStorage(cacheKey, payload)

            // 通过全局事件通知店铺页：预取数据已准备好
            try {
              window.dispatchEvent(
                new CustomEvent('shopIndexPrefetched', {
                  detail: {
                    shopId,
                    cacheKey,
                    payload,
                  },
                }),
              )
            } catch (e) {
              // 某些环境可能不支持 CustomEvent，忽略即可
            }
          } else {
            window.dispatchEvent(
              new CustomEvent('shopIndexPrefetched', {
                detail: {
                  shopId,
                  errno: res.errno,
                },
              }),
            )
          }
        })
        .catch(() => {
          // 静默处理错误，不影响路由跳转
        })
    }
  }
}

/**
 * 路由预请求处理
 */
export function handlePrefetch(to) {
  if (!is_mobile()) return
  prefetchBrandInfo(to)
  prefetchShopIndex(to)
}
